import React, { useState, useEffect } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import io from 'socket.io-client';

// const socket = io('http://son.aniplustv.com:4000');

const SeartSucc = (props) => {
  const { apiUrl, history, loginId } = props;
  let orderCode = new URL(window.location.href).searchParams.get('orderId');
  let paymentKey = new URL(window.location.href).searchParams.get('paymentKey');
  let amount = new URL(window.location.href).searchParams.get('amount');

  console.log(orderCode, loginId, amount);

  const _callApi = async () => {
    const result = await axios.post(apiUrl + '/seatReservePayment', {
      orderCode,
      paymentKey,
      amount,
      userid: loginId,
    });
    console.log(result);
    const intReturn = result.data[0].intReturn;
    const data = result.data[0].listData;
    // console.log(data);
    if (intReturn === 0) {
      // 소켓처리.
      const rtime = data[0].rtime;
      // const room = data[0].room;
      // const ticketGrade = data[0].ticketGrade
      console.log(rtime);
      // let socket = io('http://son.aniplustv.com:4000');
      let socket;

      if (rtime === '1000') {
        // socket = io('https://ticket.aniplustv.com:4000');
        // socket = io('https://ticket1.aniplustv.com');
        socket = io('https://ticket1.aniplustv.com');
      } else if (rtime === '1245') {
        socket = io('https://ticket2.aniplustv.com');
      } else if (rtime === '1520') {
        // socket = io('https://ticket3.aniplustv.com');
      }

      socket.emit('reserveSuccess', data);
      history.push('/event/352');
      setTimeout(() => {
        alert(
          '예매가 성공적으로 완료되었습니다.\n\n예매 내역을 확인해 주세요.'
        );
      }, 500);

      // window.location.href = '/seat';
      // window.self.close();
    } else {
      console.log(intReturn);

      window.location.href = '/event/352';
      setTimeout(() => {
        alert('오류가 발생했습니다.');
      }, 500);
    }
  };

  useEffect(() => {
    _callApi();
  }, []);

  return <div></div>;
};

export default shopContext(withRouter(SeartSucc));
